import axiosClient from "api/apiClient";

export const APIGetTest = (data: object) => {
    return axiosClient.post("/tests/show", data);
  };

export const APIStartTest = (data: object) => {
  return axiosClient.post(`/tests/start/`, data);
};

export const APISaveTestAnswer = (data: object) => {
  return axiosClient.post(`/tests/answer`, data);
};

export const APICloseTest = (data: object) => {
  return axiosClient.post(`/tests/close/`, data);
};

export const APIPostDeleteTest = (data: object) => {
    return axiosClient.post(`/tests/delete/`, data);
};

